import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router, RouterOutlet, RouterLinkWithHref, RouterLink, RouterLinkActive } from '@angular/router';
import {
  DropdownComponent,
  DropdownContentComponent,
  DropdownItemComponent,
  DropdownTriggerDirective
} from 'ibs.ui';
import { LoginService } from './services/login.service';
@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    CommonModule,
    RouterLinkWithHref,
    DropdownComponent,
    DropdownContentComponent,
    DropdownItemComponent,
    DropdownTriggerDirective
  ],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  loginService = inject(LoginService);
  router = inject(Router);
  dropdownAberto = false;
  menuRecepcaoAberto = false;

  /** Telas do menu "Recepção de Convênios", para destacar o grupo. */
  get naRecepcao() {
    return ['/painel-recepcao', '/validacao-arquivos', '/rastreio-pagamento', '/parametros-recepcao'].some(r => this.router.url.startsWith(r));
  }

  get usuarioLogado() {
    return this.loginService.obterUsuario();
  }

  get mostrarHeader() {
    return !this.router.url.includes('/login') && this.usuarioLogado;
  }

  abrirDropdown() {
    this.dropdownAberto = true;
  }

  fecharDropdown() {
    this.dropdownAberto = false;
  }

  navegarParaEmissao() {
    void this.router.navigate(['/emissao']);
  }

  navegarParaDuimp() {
    void this.router.navigate(['/emissao-duimp']);
  }

  deslogar() {
    this.dropdownAberto = false;
    this.loginService.deslogar();
  }
}
